import script from "./tool-use-group.vue?vue&type=script&setup=true&lang=js"
export * from "./tool-use-group.vue?vue&type=script&setup=true&lang=js"

import "./tool-use-group.vue?vue&type=style&index=0&id=3c623d24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c623d24"]])

export default __exports__